module.exports = __webpack_public_path__ + "img/_icon-change-of-address.f3923961.svg";